import React from 'react';
import { connect, useDispatch } from 'react-redux';

import Filtros from '../../commons/Filtros';

import {
  getPerfilesAction,
  getSeleccionarPerfilesAction,
} from '../../redux/actions/perfiles.action';

const PerfilesFilter = () => {
  const dispatch = useDispatch();

  return (
    <Filtros
      onFilter={() => dispatch(getPerfilesAction({}))}
      onNew={() => dispatch(getSeleccionarPerfilesAction())}
      showFilterButton={false}
    ></Filtros>
  );
};

const mapStateToProps = () => {
  return {};
};

export default connect(mapStateToProps)(PerfilesFilter);
